/* Search-only quick add: keep native cart state/app events, without opening the drawer. */
(() => {
 'use strict';
 const setup=()=>document.querySelectorAll('[data-navera-search-add]').forEach(button=>button.hidden=false);
 document.addEventListener('navera:search-rendered',setup);
 document.addEventListener('shopify:section:load',setup);
 setup();
 document.addEventListener('click', async event => {
  const button=event.target.closest('[data-navera-search-add]');
  if(!button || button.disabled || button.dataset.busy==='true')return;
  const card=button.closest('.navera-search-card'),status=card.querySelector('[data-navera-search-status]');
  const root=(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  button.dataset.busy='true';button.disabled=true;button.setAttribute('aria-busy','true');status.textContent='Adding…';
  let added=false;
  try {
   const sections=[];document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections',{bubbles:true,detail:{sections}}));
   const response=await fetch(window.FoxTheme?.routes?.cart_add_url || root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:button.dataset.variantId,quantity:Number(button.dataset.quantity)||1}],sections,sections_url:location.pathname})});
   const data=await response.json();
   if(!response.ok || data.status)throw new Error(typeof data.description==='string'?data.description:'This item could not be added. Please try again.');
   added=true;
   const cartResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
   if(!cartResponse.ok)throw new Error('Basket added, but its display could not be refreshed.');
   const cart=await cartResponse.json();cart.sections=data.sections;
   if(window.FoxTheme?.pubsub)FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart});
   document.dispatchEvent(new CustomEvent('product-ajax:added',{detail:{product:data}}));
   status.textContent='Added to basket.';
   const link=document.createElement('a');link.href=root+'cart';link.textContent='View basket';status.append(' ',link);
  } catch(error) {
   status.textContent=added?'Added to basket. Open your basket to check the latest total.':error.message || 'Connection problem. Please try again.';
   if(added){const link=document.createElement('a');link.href=root+'cart';link.textContent='View basket';status.append(' ',link);}
  } finally {button.dataset.busy='false';button.disabled=false;button.removeAttribute('aria-busy');}
 });
})();

/* Reuse the page's minimal cart snapshot and native cart updates. No extra requests. */
(() => {
 'use strict';
 let quantities=new Map();
 const paint=(scope=document)=>{
  const nodes=scope.matches?.('[data-navera-basket-product]')?[scope]:scope.querySelectorAll?.('[data-navera-basket-product]')||[];
  nodes.forEach(node=>{
   const quantity=quantities.get(node.dataset.naveraBasketProduct)||0;
   const text=quantity>0?'✓ In your basket · '+quantity:'';
   const label=node.firstElementChild;
   if(!label)return;
   if(label.textContent!==text)label.textContent=text;
   label.hidden=!quantity;
  });
 };
 const update=items=>{
  if(!Array.isArray(items))return;
  quantities=new Map();
  items.forEach(item=>{
   const id=String(item.product_id),q=Number(item.quantity)||0;
   if(q>0)quantities.set(id,(quantities.get(id)||0)+q);
  });
  paint();
 };
 try {update(JSON.parse(document.getElementById('navera-card-cart-state')?.textContent||'[]'));}catch(error){/* Keep unknown basket state quiet. */}
 const subscribe=()=>{
  const bus=window.FoxTheme?.pubsub;
  if(bus?.subscribe && bus.PUB_SUB_EVENTS?.cartUpdate){
   bus.subscribe(bus.PUB_SUB_EVENTS.cartUpdate,({cart}={})=>update(cart?.items));
  }
 };
 subscribe();
 document.addEventListener('navera:search-rendered',()=>paint());
 document.addEventListener('shopify:section:load',event=>paint(event.target));
 new MutationObserver(records=>{
  records.forEach(record=>record.addedNodes.forEach(node=>{
   if(node.nodeType===1 && (node.matches('[data-navera-basket-product]')||node.querySelector('[data-navera-basket-product]')))paint(node);
  }));
 }).observe(document.body,{childList:true,subtree:true});
})();

/* Shelf sizing is local and request-free. Full titles remain visible and rows align. */
(() => {
 const selector='.navera-brand-products__grid,.section--related-products .products-grid,.navera-collection-grid';
 const initialized=new WeakSet();
 const setup=()=>document.querySelectorAll(selector).forEach(grid=>{
  if(initialized.has(grid))return;
  initialized.add(grid);
  const surface=grid.closest('.navera-recommendations-surface');
  const buttons=surface?.querySelectorAll('[data-navera-shelf-scroll]')||[];
  let frame, resetPending = false, measureTitles = true, active = false, observedWidth;
  const refresh=(remeasure=true)=>{
   if (!active) return;
   measureTitles = measureTitles || remeasure !== false;
   if (resetPending) return;
   cancelAnimationFrame(frame);
   frame=requestAnimationFrame(()=>{
    if (measureTitles) {
     // Clear old constraints in a separate frame from the geometry reads.
     resetPending = true;
     grid.querySelectorAll('.product-card__title').forEach(t=>t.style.minHeight='');
     frame=requestAnimationFrame(measure);
    } else measure();
   });
  };
  const measure=()=>{
    resetPending = false;
    const max=grid.scrollWidth-grid.clientWidth;
    const left=grid.scrollLeft;
    if (measureTitles) {
     measureTitles = false;
     const titles=[...grid.querySelectorAll('.product-card__title')];
     const groups=new Map();
     // Finish all geometry reads before applying the final row heights.
     titles.forEach(t=>{
      const key=grid.matches('.navera-collection-grid')?Math.round(t.closest('.product-column')?.getBoundingClientRect().top||0):0;
      const row=groups.get(key)||{height:0,titles:[]};
      row.height=Math.max(row.height,Math.ceil(t.getBoundingClientRect().height));
      row.titles.push(t);groups.set(key,row);
     });
     groups.forEach(row=>row.titles.forEach(t=>t.style.minHeight=row.height+'px'));
    }
    buttons.forEach(button=>{
     button.hidden=max<2;
     button.disabled=Number(button.dataset.naveraShelfScroll)<0?left<2:left>=max-2;
    });
  };
  buttons.forEach(button=>button.addEventListener('click',()=>{
   const first=grid.firstElementChild;
   const distance=first?first.getBoundingClientRect().width+12:grid.clientWidth;
   grid.scrollBy({left:Number(button.dataset.naveraShelfScroll)*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }));
  grid.addEventListener('scroll',()=>refresh(false),{passive:true});
  const activate = () => { active = true; refresh(); };
  new ResizeObserver(entries => {
   const width = entries[0]?.contentRect.width;
   if (width === observedWidth) return;
   observedWidth = width;
   refresh();
  }).observe(grid);
  document.fonts?.ready.then(() => refresh());
  if ('IntersectionObserver' in window) {
   const observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    activate(); observer.disconnect();
   }, {rootMargin:'300px 0px'});
   observer.observe(grid);
  } else activate();
 });
 setup();
 document.addEventListener('shopify:section:load',setup);
 new MutationObserver(records=>{
  if(records.some(record=>[...record.addedNodes].some(n=>n.nodeType===1&&(n.matches(selector)||n.querySelector(selector)))))setup();
 }).observe(document.body,{subtree:true,childList:true});
})();


/* Keep desktop menu panels within the actual remaining viewport, including sticky headers. */
(() => {
 const header = document.querySelector('.header');
 if (!header) return;
 let frame;
 const fit = () => {
  if (!matchMedia('(min-width:1024px)').matches) return;
  const updates = [...header.querySelectorAll('details[open] .mega-menu')]
   .filter(menu => menu.closest('details')?.open)
   .map(menu => ({menu, top:menu.getBoundingClientRect().top}));
  updates.forEach(({menu,top}) => {
   if (top < 0 || top >= innerHeight) return;
   const value = `${Math.max(120, innerHeight - top - 12)}px`;
   if (menu.style.getPropertyValue('--navera-menu-available') !== value) menu.style.setProperty('--navera-menu-available', value);
  });
 };
 const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); };
 header.addEventListener('pointerover', schedule);
 header.addEventListener('focusin', schedule);
 header.addEventListener('toggle', schedule, true);
 window.addEventListener('resize', schedule);
 if (window.ResizeObserver) new ResizeObserver(schedule).observe(header);
 schedule();
})();
